export function setCookie(cname, cValue, exDays = 365) {
  let d = new Date()
  d.setTime(d.getTime() + exDays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cValue + ';' + expires + ';path=/'
}

export function getCookie(cname) {
  const name = cname + '='
  const ca = document.cookie.split(';')

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

export function deleteCookie(cname) {
  const host = window.location.host
  let domain = host.replace('subscription.', '')
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; Secure; domain=${domain}`
}
